import {
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Tooltip,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import {
  AbraFlexiExportModal,
  type AbraFlexiExportModalRef,
} from "@src/components/modules/common/exports/abraflexi/AbraFlexiExportModal";
import { ExportFinancialDocumentsButton } from "@src/components/modules/common/exports/financial-documents/ExportFinancialDocumentsButton";
import {
  ButtonLink,
  DataTable,
  ExportButton,
  NavBar as NavBarCmp,
} from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { appStore } from "@src/stores/AppStore";
import { can } from "@src/utils/components/permissions";
import { observer } from "mobx-react-lite";
import { useRef } from "react";
import { useStore } from "../../store";
import { QuickFilters } from "./QuickFilters";

export const NavBar = observer(function NavBar() {
  const abraFlexiExportModalRef = useRef<AbraFlexiExportModalRef>(null);
  const store = useStore();

  return (
    <DataTable.NavBar>
      <NavBarCmp justify="space-between">
        <QuickFilters />
        <HStack spacing="3">
          <AbraFlexiExportModal ref={abraFlexiExportModalRef} />
          <Menu>
            <MenuButton
              as={ExportButton}
              isLoading={
                store.isPohodaExporting ||
                store.isOmegaExporting ||
                store.isPremierExporting
              }
              rightIcon={<Icon name="chevron-down" />}
            />
            <MenuList>
              <MenuItem onClick={abraFlexiExportModalRef.current?.open}>
                <Trans>ABRA</Trans>
              </MenuItem>
              <ExportFinancialDocumentsButton />
              {appStore.workspaceStore.settings?.exportSettings.pohoda && (
                <Tooltip
                  hasArrow
                  isDisabled={!store.areExportsDisabled}
                  label={t`Select invoices to export`}
                  placement="top"
                >
                  <MenuItem
                    isDisabled={store.areExportsDisabled}
                    onClick={() => store.exportPohoda(store.selectedInvoiceIds)}
                  >
                    <Trans>Pohoda</Trans>
                  </MenuItem>
                </Tooltip>
              )}
              {appStore.workspaceStore.settings?.exportSettings.premier && (
                <Tooltip
                  hasArrow
                  isDisabled={!store.areExportsDisabled}
                  label={t`Select invoices to export`}
                  placement="top"
                >
                  <MenuItem
                    isDisabled={store.areExportsDisabled}
                    onClick={() =>
                      store.exportPremier(store.selectedInvoiceIds)
                    }
                  >
                    <Trans>Premier</Trans>
                  </MenuItem>
                </Tooltip>
              )}
              {appStore.workspaceStore.settings?.exportSettings.omega && (
                <Tooltip
                  hasArrow
                  isDisabled={!store.areExportsDisabled}
                  label={t`Select invoices to export`}
                  placement="top"
                >
                  <MenuItem
                    isDisabled={store.areExportsDisabled}
                    onClick={() => store.exportOmega(store.selectedInvoiceIds)}
                  >
                    <Trans>OMEGA</Trans>
                  </MenuItem>
                </Tooltip>
              )}
            </MenuList>
          </Menu>
          {can([
            "requestForInvoicing_create_all",
            "requestForInvoicing_create_own",
            "requestForInvoicing_create_team",
          ]) && (
            <ButtonLink
              href={{ pathname: "/invoices/for-invoicing/create-proforma" }}
            >
              <Trans>Add new</Trans>
            </ButtonLink>
          )}
        </HStack>
      </NavBarCmp>
    </DataTable.NavBar>
  );
});
